export const DEFAULT_LANDING_PAGE = '/';
export const MAX_HOURS_WARNING = 30;
export const NEXT_DAY_CONFIRMATION_TIME = '12:15'; // 12:15pm CST
export const MAX_BONUS_AMOUNT = 500;
export const MAX_OVERBOOK_SLOTS = 100;
